import { DocumentsList } from "Components/LegalDocuments/DocumentsList";
import { MerchantCurrentPricingDocuments } from "Components/LegalDocuments/MerchantCurrentPricingDocuments";
import { BlDivider } from "Components/Shared/BlDivider";
import { getApiUrl } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Pages.Content.LegalDocuments.Documents;

export const MerchantLegalDocuments = () => {
  const { t } = useResource();
  const apiUrl = getApiUrl();

  const documents = [
    {
      title: t(COMPONENT_RESOURCES.paymentServicesContract.title),
      url: t(COMPONENT_RESOURCES.paymentServicesContract.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.generalBusinessTerms.title),
      url: t(COMPONENT_RESOURCES.generalBusinessTerms.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.merchantTerms.title),
      url: t(COMPONENT_RESOURCES.merchantTerms.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.aisPisProductTerms.title),
      url: t(COMPONENT_RESOURCES.aisPisProductTerms.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.settlementManual.title),
      url: t(COMPONENT_RESOURCES.settlementManual.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.complaintRules.title),
      url: t(COMPONENT_RESOURCES.complaintRules.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.dataProtectionMemorandum.title),
      url: t(COMPONENT_RESOURCES.dataProtectionMemorandum.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.precontractInformation.title),
      url: t(COMPONENT_RESOURCES.precontractInformation.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.thanksToYou.title),
      url: t(COMPONENT_RESOURCES.thanksToYou.url, { apiUrl }),
    },
  ];

  return (
    <>
      <DocumentsList documents={documents} />
      <MerchantCurrentPricingDocuments />
      <BlDivider
        text={t(Resources.Pages.Content.LegalDocuments.previousVersions)}
      />
      <DocumentsList
        documents={[
          {
            title: t(
              COMPONENT_RESOURCES.previousDataProtectionMemorandum.title,
            ),
            url: t(COMPONENT_RESOURCES.previousDataProtectionMemorandum.url, {
              apiUrl,
            }),
          },
          {
            title: t(
              COMPONENT_RESOURCES.previousDataProtectionMemorandum2.title,
            ),
            url: t(COMPONENT_RESOURCES.previousDataProtectionMemorandum2.url, {
              apiUrl,
            }),
          },
          {
            title: t(COMPONENT_RESOURCES.previousGeneralBusinessTerms.title),
            url: t(COMPONENT_RESOURCES.previousGeneralBusinessTerms.url, {
              apiUrl,
            }),
          },
        ]}
      />
    </>
  );
};
